window.helper = {
    formatDecimal: (value) => {
        return new Intl.NumberFormat('id', { style: 'decimal' })
            .format(Number(value));
    },

    formatCurrency: (value) => {
        const formatter = new Intl.NumberFormat('id', {
            style: 'currency',
            currency: 'IDR'
        });

        return formatter.format(Number(value));
    },

    formatDate: (text) => {
        return new Date(text)
            .toLocaleString('id', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
    }
};
